
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/raffles/history",
      function () {
        return require("private-next-pages/raffles/history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/raffles/history"])
      });
    }
  